@if (showDeveloperUI$ | async) {
  <app-developer-menu></app-developer-menu>
}

<gbc-topbar
  [title]="'core.igrid-description-title' | translate"
  (headerClick)="navigateToRoot()"
  [ngClass]="{ developerVisible: (showDeveloperUI$ | async) }"
  >
  @if (currentUser$ | async; as user) {
    <gbc-topbar-dropdown [placeholder]="user.name">
      @if (showSupportButton$ | async) {
        <button gbc-topbar-dropdown-item [routerLink]="['/support']">
          {{ 'root-page.support' | translate }}
        </button>
      }
      @if (showCommissionButton$ | async) {
        <button gbc-topbar-dropdown-item [routerLink]="['/commission']">
          {{ 'root-page.commission' | translate }}
        </button>
      }
      @if (showArchiveButton$ | async) {
        <button gbc-topbar-dropdown-item [routerLink]="['/archive']">
          {{ 'root-page.archive' | translate }}
        </button>
      }
      <button gbc-topbar-dropdown-item (click)="logout()">
        {{ 'app-menu-logout' | translate }}
      </button>
    </gbc-topbar-dropdown>
  }
</gbc-topbar>
<div class="outlet-container">
  <gbc-page-spinner>
    <gbc-page-error-handler [pageError$]="pageError$" [content]="content"> </gbc-page-error-handler>
    <ng-template #content>
      <router-outlet></router-outlet>
    </ng-template>
  </gbc-page-spinner>
</div>
